<div class="container-fluid complyon-page calendar-page px-3 px-md-4 px-xl-4 py-3">
  <div class="complyon-shell calendar-shell mx-auto">
    <section class="mb-3">
      <h1 class="complyon-title calendar-title mb-2 text-l">Regulatory calendar</h1>
      <p class="complyon-subtitle calendar-subtitle mb-0 text-s">
        Tax deadlines, filings, licence renewals, audit dates, policy reviews and document expiries.
      </p>
    </section>

    <section class="d-flex align-items-center justify-content-between gap-3 mb-3">
      <div class="regcal-tabs d-flex align-items-center gap-1">
        <button
          v-for="tab in tabs"
          :key="tab.key"
          type="button"
          class="regcal-tab"
          :class="{ 'is-active': active_tab === tab.key }"
          @click="set_tab(tab.key)"
        >
          <span>{{ tab.label }}</span>
          <span v-if="tab.count" class="ms-1">{{ tab.count }}</span>
          <span v-if="tab.alert" class="regcal-tab-alert">{{ tab.alert }}</span>
        </button>
      </div>

      <button
        type="button"
        class="btn btn-link text-secondary text-decoration-none d-inline-flex align-items-center gap-2 px-0"
      >
        <i class="bi bi-arrow-counterclockwise"></i>
        <span>Reset sample</span>
      </button>
    </section>

    <div v-if="active_tab === 'timeline'">
      <div class="regcal-summary-grid mb-3">
        <div class="complyon-panel regcal-summary-card">
          <div class="regcal-stat-label">Tracked deadlines</div>
          <div class="regcal-stat-value">19</div>
          <div class="regcal-stat-note">Across 9 categories</div>
        </div>
        <div class="complyon-panel regcal-summary-card">
          <div class="regcal-stat-label">Overdue</div>
          <div class="regcal-stat-value regcal-value-danger">3</div>
          <div class="regcal-stat-note">Escalation active</div>
        </div>
        <div class="complyon-panel regcal-summary-card">
          <div class="regcal-stat-label">Due this week</div>
          <div class="regcal-stat-value regcal-value-warning">3</div>
          <div class="regcal-stat-note">Next 7 days</div>
        </div>
        <div class="complyon-panel regcal-summary-card">
          <div class="regcal-stat-label">Due this month</div>
          <div class="regcal-stat-value regcal-value-warning">10</div>
          <div class="regcal-stat-note">Next 31 days</div>
        </div>
      </div>

      <section class="d-flex align-items-center justify-content-between gap-2 mb-3 flex-wrap">
        <div class="regcal-chip-list d-flex align-items-center gap-2 flex-wrap">
          <button type="button" class="regcal-chip is-active">All categories</button>
          <button
            v-for="item in category_legend"
            :key="item.key"
            type="button"
            class="regcal-chip"
          >
            <span class="regcal-chip-dot" :class="item.dot_class"></span>
            <span>{{ item.label }}</span>
          </button>
        </div>
        <button type="button" class="btn btn-primary-dark d-inline-flex align-items-center gap-2 px-3 py-2 rounded-3 fw-semibold">
          <i class="bi bi-plus-lg"></i><span>Add deadline</span>
        </button>
      </section>

      <div class="d-grid gap-3">
        <section
          v-for="group in timeline_groups"
          :key="group.key"
          class="complyon-panel regcal-timeline-card overflow-hidden"
        >
          <div class="regcal-section-header d-flex align-items-center justify-content-between gap-2 px-3 pt-3 pb-2">
            <div class="d-flex align-items-center gap-2">
              <h2 class="regcal-section-title mb-0">{{ group.title }}</h2>
              <span class="regcal-section-count">{{ group.count }}</span>
            </div>
          </div>

          <div class="regcal-timeline-items">
            <div
              v-for="item in group.items"
              :key="group.key + item.title"
              class="regcal-timeline-row d-flex align-items-start gap-3 px-3 py-3"
            >
              <div class="regcal-date-badge" :class="group.key === 'overdue' ? 'is-overdue' : group.key === 'this_week' ? 'is-warning' : group.key === 'this_month' ? 'is-warning' : 'is-future'">
                <div class="regcal-date-day">{{ item.day }}</div>
                <div class="regcal-date-month">{{ item.month }}</div>
              </div>

              <div class="regcal-item-icon" :class="item.icon_class">
                <i class="bi" :class="item.icon"></i>
              </div>

              <div class="flex-grow-1 min-w-0">
                <div class="regcal-item-title">{{ item.title }}</div>
                <div class="regcal-item-meta">{{ item.meta }}</div>
              </div>

              <div class="regcal-timeline-right text-end ms-auto">
                <span class="regcal-due-pill" :class="item.right_class">{{ item.right_label }}</span>
                <div v-if="item.escalation" class="regcal-escalation-line">
                  <i class="bi bi-arrow-up-right"></i>
                  <span>{{ item.escalation }}</span>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>

    <div v-else-if="active_tab === 'month'">
      <section class="complyon-panel regcal-month-card overflow-hidden">
        <div class="d-flex align-items-center justify-content-between gap-3 px-3 py-3 border-bottom">
          <div class="d-flex align-items-center gap-3">
            <button type="button" class="btn btn-link text-secondary text-decoration-none p-0 regcal-month-nav">
              <i class="bi bi-chevron-left"></i>
            </button>
            <div class="regcal-month-label">{{ month_label }}</div>
            <button type="button" class="btn btn-link text-secondary text-decoration-none p-0 regcal-month-nav">
              <i class="bi bi-chevron-right"></i>
            </button>
          </div>
          <div class="regcal-chip-list d-flex align-items-center gap-3 flex-wrap justify-content-end">
            <span
              v-for="item in category_legend"
              :key="item.key"
              class="regcal-month-legend d-inline-flex align-items-center gap-2"
            >
              <span class="regcal-month-legend-dot" :class="item.dot_class"></span>
              <span>{{ item.label }}</span>
            </span>
          </div>
        </div>

        <div class="regcal-calendar-grid">
          <div class="regcal-day-head" v-for="day in ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN']" :key="day">{{ day }}</div>

          <div
            v-for="(week, week_index) in month_weeks"
            :key="'week-' + week_index"
            class="regcal-week-row"
          >
            <div
              v-for="(day, day_index) in week"
              :key="week_index + '-' + day_index"
              class="regcal-day-cell"
              :class="{ 'is-empty': day.empty, 'is-selected': day.selected }"
            >
              <div v-if="!day.empty" class="regcal-day-content">
                <div class="regcal-day-number">{{ day.day }}</div>
                <span v-if="day.dot_class" class="regcal-day-dot" :class="day.dot_class"></span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

    <div v-else-if="active_tab === 'category'">
      <div class="regcal-category-grid">
        <section
          v-for="card in category_cards"
          :key="card.title"
          class="complyon-panel regcal-category-card overflow-hidden"
        >
          <div class="d-flex align-items-start justify-content-between gap-3 mb-2">
            <div class="regcal-category-icon" :class="card.icon_class">
              <i class="bi" :class="card.icon"></i>
            </div>
            <span class="regcal-due-pill" :class="card.badge_class">{{ card.badge }}</span>
          </div>

          <div class="regcal-category-title">{{ card.title }}</div>
          <div class="regcal-category-count">
            <strong>{{ card.count }}</strong> upcoming
          </div>
          <div class="regcal-category-next">
            Next: <span>{{ card.next_label }}</span> - <strong>{{ card.next_date }}</strong>
          </div>
        </section>
      </div>
    </div>

    <div v-else-if="active_tab === 'reminders'">
      <section class="complyon-panel regcal-reminder-card overflow-hidden mb-3">
        <div class="d-flex align-items-center justify-content-between gap-2 px-3 pt-3 pb-2 border-bottom">
          <div>
            <div class="regcal-section-title">Recurring reminder rules</div>
            <div class="regcal-section-subtitle">Automatic reminders fire at each offset before a deadline's due date.</div>
          </div>
        </div>

        <div class="regcal-reminder-table">
          <div class="regcal-reminder-head">
            <div>Reminder rule</div>
            <div>Fires at (days before)</div>
            <div>Channel</div>
            <div>Recipients</div>
            <div>Active</div>
          </div>

          <div
            v-for="rule in reminder_rules"
            :key="rule.rule"
            class="regcal-reminder-row"
          >
            <div class="regcal-reminder-name">{{ rule.rule }}</div>
            <div class="regcal-reminder-fires">
              <span
                v-for="fire in rule.fires"
                :key="rule.rule + fire"
                class="regcal-fire-pill"
              >
                <i class="bi bi-bell"></i>
                <span>{{ fire }}</span>
              </span>
            </div>
            <div class="regcal-reminder-channel">{{ rule.channel }}</div>
            <div class="regcal-reminder-recipients">{{ rule.recipients }}</div>
            <div class="regcal-toggle" :class="{ 'is-on': rule.active }" aria-hidden="true">
              <span class="regcal-toggle-knob"></span>
            </div>
          </div>
        </div>
      </section>

      <section class="complyon-panel regcal-ladder-card overflow-hidden">
        <div class="d-flex align-items-center justify-content-between gap-2 px-3 pt-3 pb-2 border-bottom">
          <div>
            <div class="regcal-section-title">Escalation ladder for overdue items</div>
            <div class="regcal-section-subtitle">Every tracked deadline follows this path once it passes its due date - nothing slips silently.</div>
          </div>
        </div>

        <div class="regcal-ladder-list">
          <div
            v-for="step in escalation_steps"
            :key="step.step"
            class="regcal-ladder-row"
          >
            <div class="regcal-step-number">{{ step.step }}</div>
            <div class="regcal-step-bar"></div>
            <div class="flex-grow-1">
              <div class="regcal-step-title">{{ step.title }}</div>
              <div class="regcal-step-description">{{ step.description }}</div>
            </div>
            <div class="regcal-owner-pill">{{ step.owner }}</div>
          </div>
        </div>
      </section>
    </div>
  </div>
</div>
